<template>
  <div>
    <v-flex xs12>
      <v-data-table
        :loading-text="table.title"
        :server-items-length="table.total"
        :headers="table.headers"
        :loading="table.loading"
        :items="table.data"
        :options="table.options"
        item-key="name"
        :no-data-text="$t('management.tablePurchaseReport.noData')"
        :footer-props="{
          'items-per-page-options': [30, 50, 100, 150]
        }"
        sort-by="name"
        @update:options="updateTable"
        class="elevation-1 fixed-header">
        <template v-slot:top>
          <div class="px-3 filters">
            <v-row>
              <v-col cols="3">
                <div class="d-flex align-center">
                  <span class="mr-3">
                    {{$t('management.labels.filters')}}
                  </span>
                  <v-menu
                    ref="datePicker"
                    v-model="datePicker"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="range"
                        :label="$t('management.labels.range')"
                        prepend-icon="mdi-calendar"
                        readonly
                        hide-details
                        dense
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="month"
                      first-day-of-week="1"
                      :max="untilToday"
                      type="month"
                      color="primary"
                      no-title
                    >
                      <v-btn text color="primary" @click="resetDate">{{$t('management.buttons.actions.reset')}}</v-btn>
                      <v-spacer/>
                      <v-btn text color="grey" @click="datePicker = false">{{$t('management.buttons.actions.cancel')}}</v-btn>
                      <v-btn :disabled="dates.length < 2" color="primary" @click="filterByDate">{{$t('management.buttons.actions.save')}}</v-btn>
                    </v-date-picker>
                  </v-menu>
                </div>
              </v-col>
            </v-row>
          </div>
        </template>
        <template v-slot:item.action="{ item }">
          <div class="d-flex justify-end align-center">
            <v-tooltip left>
              <template
                v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  class="mr-3"
                  fab
                  color="primary"
                  x-small
                  depressed
                  target="_blank"
                  :href="exportRoute(item)">
                  <v-icon color="white">
                    mdi-application-export
                  </v-icon>
                </v-btn>
              </template>
              <span>{{$t('management.tooltips.exportCSV')}}</span>
            </v-tooltip>
            <v-tooltip left>
              <template
                v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  class="mr-3"
                  fab
                  color="secondary"
                  x-small
                  depressed
                  @click="downloadXML(item)">
                  <v-icon color="white">
                    mdi-receipt
                  </v-icon>
                </v-btn>
              </template>
              <span>{{$t('management.tooltips.downloadXML')}}</span>
            </v-tooltip>
            <!-- <v-tooltip left>
              <template
                v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  depressed
                  fab
                  x-small
                  :href="exportRoute"
                  color="primary">
                    <v-icon>mdi-book-open</v-icon>
                </v-btn>
              </template>
              <span>Descargar estados de cuenta eato con uuid</span>
            </v-tooltip> -->
          </div>
        </template>
        <template v-slot:item.name="{ item }">
          <div>
            {{ statusName(item.name) }}
          </div>
        </template>
        <template v-slot:item.subtotalIVA="{ item }">
          {{ item.subtotalIVA | toFixNumber(2) | numberWithComma  | prefix('$') }}
        </template>
        <template v-slot:item.subtotalNotIVA="{ item }">
          {{ item.subtotalNotIVA | toFixNumber(2) | numberWithComma  | prefix('$') }}
        </template>
        <template v-slot:item.iva="{ item }">
          {{ item.iva | toFixNumber(2) | numberWithComma | prefix('$') }}
        </template>
        <template v-slot:item.ieps="{ item }">
          {{ item.ieps | toFixNumber(2) | numberWithComma | prefix('$') }}
        </template>
        <template v-slot:item.total="{ item }">
          {{ item.total | toFixNumber(2) | numberWithComma | prefix('$') }}
        </template>
      </v-data-table>
    </v-flex>
    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import { isEqual } from 'lodash'
import moment from 'moment'

export default {
  name: 'PurchaseReport',
  data () {
    return {
      overlay: false,
      datePicker: false,
      month: new Date().toISOString(),
      table: {
        title: this.$i18n.t('management.tablePurchaseReport.title'),
        headers: [
          { text: this.$i18n.t('management.tablePurchaseReport.headers.name'), value: 'name', sortable: false },
          { text: this.$i18n.t('management.tablePurchaseReport.headers.subtotalNotIva'), value: 'subtotalIVA', sortable: false },
          { text: this.$i18n.t('management.tablePurchaseReport.headers.subtotalIva'), value: 'subtotalNotIVA', sortable: false },
          { text: this.$i18n.t('management.tablePurchaseReport.headers.iva'), value: 'iva', sortable: false },
          { text: this.$i18n.t('management.tablePurchaseReport.headers.ieps'), value: 'ieps', sortable: false },
          { text: this.$i18n.t('management.tablePurchaseReport.headers.total'), value: 'total', sortable: false },
          { text: this.$i18n.t('management.tablePurchaseReport.headers.actions'), value: 'action', sortable: false, align: 'center' }
        ],
        loading: true,
        data: [],
        total: 1,
        options: {
          groupBy: [],
          groupDesc: [],
          itemsPerPage: 50,
          multiSort: false,
          mustSort: false,
          page: 1,
          sortBy: [''],
          sortDesc: []
        }
      }
    }
  },
  computed: {
    range () {
      return this.dates.length < 2 ? '' : `${this.dates[0]} / ${this.dates[1]}`
    },
    restaurant () {
      return this.$store.state.currentRestaurant.data
    },
    dates () {
      const dates = []
      if (this.$moment(this.month).isValid()) {
        const start = this.$moment(this.month).startOf('month').format('YYYY-MM-DD')
        const end = this.$moment(this.month).endOf('month').format('YYYY-MM-DD')
        dates.push(start, end)
      }
      return dates
    },
    untilToday () {
      return moment().format('YYYY-MM-DD')
    }
  },
  watch: {
    restaurant: {
      handler: async function (val) {
        await this.load()
      },
      deep: true
    }
  },
  mounted: async function () {
    this.load()
  },
  methods: {
    async downloadXML (item) {
      const startDate = this.$moment(this.dates[0])
      const endDate = this.$moment(this.dates[1])
      try {
        let url = item.name === 'paid'
          ? `/v1/reports/${this.$store.state.currentRestaurant.data._id}/accounting/export/paid-purchases?`
          : `/v1/reports/${this.$store.state.currentRestaurant.data._id}/accounting/export/invoiced-purchases?`
        url += `output=zip`
        url += `&restaurant=${this.$store.state.currentRestaurant.data._id}`
        url += `&createdAt>=${startDate.startOf('day').toISOString() || ''}`
        url += `&createdAt<=${endDate.endOf('day').toISOString() || ''}`
        url += `&status=${item.name}`
        await this.$api.get(url)
        this.$toasted.show('Se enviará a su correo el link para descargar las facturas emitadas', { duration: 3000, type: 'success' })
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
    },
    async resetDate () {
      this.month = new Date().toISOString()
      await this.load()
      this.datePicker = false
    },
    filterByDate () {
      this.load()
      this.datePicker = false
    },
    updateTable: async function (data) {
      if (!isEqual(data, this.table.options)) {
        this.table.options = data
        if (this.$store.state.area) {
          await this.load({
            limit: data.itemsPerPage,
            skip: (data.itemsPerPage * (data.page - 1)),
            restaurant: this.$store.state.currentRestaurant.data._id
          })
        }
      }
    },
    async load (params = null) {
      params = params || {
        limit: this.table.options.itemsPerPage,
        skip: (this.table.options.itemsPerPage * (this.table.options.page - 1)),
        restaurant: this.$store.state.currentRestaurant.data._id
      }
      if (this.dates.length) {
        params['createdAt>'] = this.$moment(this.dates[0]).startOf('day').toISOString()
        params['createdAt<'] = this.$moment(this.dates[1]).endOf('day').toISOString()
      }
      this.table.loading = true
      try {
        const response = await this.$api.get(`/v1/reports/${this.$store.state.currentRestaurant.data._id}/accounting/purchases`, params)
        this.table.data = response
        this.table.total = response.length
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.table.loading = false
    },
    statusName (status) {
      return {
        // invoiced: 'Ordenes de compra facturadas',
        received: 'Facturas emitidas en el mes',
        paid: 'Facturas pagadas en el mes'
      }[status]
    },
    exportRoute (item) {
      const dates = this.dates.length === 2
        ? [this.$moment(this.dates[0]).startOf('day').toISOString(), this.$moment(this.dates[1]).endOf('day').toISOString()]
        : [null, null]
      let url = item.name === 'paid'
        ? `${process.env.VUE_APP_API_URL}/v1/reports/${this.$store.state.currentRestaurant.data._id}/accounting/export/paid-purchases`
        : `${process.env.VUE_APP_API_URL}/v1/reports/${this.$store.state.currentRestaurant.data._id}/accounting/export/invoiced-purchases`
      url += `?output=csv&access_token=${this.$store.state.login.token}`
      url += `&restaurant=${this.$store.state.currentRestaurant.data._id}`
      url += `&status=${item.name}`
      url += `&createdAt>=${dates[0]}&createdAt<=${dates[1]}`
      return url
    }
  }
}
</script>
